import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { EditResourceForm } from '@/areas/manufacturing-templates/Resources/ResourceCreation/EditResourceForm';
import { canEditManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { PageLayout } from '@/shared/ui/PageLayout';

export const Route = createFileRoute('/_authenticated/manufacturing/resources/$resourceId/edit')({
    staticData: { access: { permissions: canEditManufacturingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <PageLayout layout="full-width">
            <EditResourceForm resourceId={pathParams.resourceId} />
        </PageLayout>
    );
}
